module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "cb-link",
      rawName: "v-cb-link",
      value: ('shadow'),
      expression: "'shadow'"
    }],
    staticClass: "cb-section cb-bar",
    class: [{
      'cb-bar--left': _vm.navIcon == 'left',
      'cb-bar--right': _vm.navIcon == 'right'
    }],
    attrs: {
      "role": 'navigation',
      "data-cb-id": "estimate-fixed"
    },
    on: {
      "click": function($event) {
        _vm.navigate()
      }
    }
  }, [_c('div', {
    staticClass: "cb-bar__wrap cb-bar__wrap--nohover"
  }, [_c('div', {
    staticClass: "cb-bar__content"
  }, [_c('div', {
    staticClass: "cb-bar__items"
  }, [_c('div', {
    staticClass: "cb-bar__item",
    style: (_vm.themeColor)
  }, [_c('div', {
    staticClass: "cb-bar__main"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('cart.pay_now.label')))])]), _vm._v(" "), _c('div', {
    staticClass: "cb-bar__aside"
  }, [_vm._v(_vm._s(_vm._f("cbCurrency")(_vm.current_amount_due, _vm.currency_code)))])]), _vm._v(" "), (_vm.firstNextEstimate) ? _c('div', {
    staticClass: "cb-bar__item"
  }, [_c('div', {
    staticClass: "cb-bar__main"
  }, [_c('span', [_vm._v(_vm._s(_vm.t('cart.next_charge.label', {
    date: _vm.date(_vm.firstNextEstimate.date)
  })))])]), _vm._v(" "), _c('div', {
    staticClass: "cb-bar__aside"
  }, [_vm._v(_vm._s(_vm._f("cbCurrency")(_vm.nextInvTotal, _vm.currency_code)))])]) : _vm._e()])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-598081b8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/hosted-pages/EstimateFixed.vue
// module id = 382
// module chunks = 42 66